import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NumberInputComponent } from '@examdojo/core/input';
import { SingleSelectComponent } from '@examdojo/core/select';

interface SelectOption {
  label: string;
  value: string;
}

@Component({
  selector: 'dojo-gojs-link-properties-panel',
  standalone: true,
  imports: [ReactiveFormsModule, NumberInputComponent, SingleSelectComponent],
  templateUrl: './gojs-link-properties-panel.component.html',
  styleUrl: './gojs-link-properties-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GojsLinkPropertiesPanelComponent {
  readonly linkData = input.required<Record<string, unknown>>();

  // Form controls passed from parent
  readonly linkColorCtrl = input.required<FormControl<string>>();
  readonly linkArrowCtrl = input.required<FormControl<string>>();
  readonly linkWidthCtrl = input.required<FormControl<number>>();

  // Select options passed from parent
  readonly linkColorOptions = input.required<Array<{ label: string; value: string }>>();
  readonly arrowOptions = input.required<SelectOption[]>();

  @Output() readonly linkColorChange = new EventEmitter<string>();
  @Output() readonly arrowChange = new EventEmitter<string>();
  @Output() readonly widthChange = new EventEmitter<number | null>();
}
